/**
 * Shared tab panel layout — plain Tailwind class strings.
 *
 * Office task panes need an unbroken height chain (html → #root → provider →
 * shell → tab panel → scroll area). Use `panel` on the tab root and `scrollArea`
 * for the one scrollable element.
 */

const tabLayoutClasses = {
  /** Fill remaining height, clip overflow — use on the tab root div. */
  panel: 'flex-1 h-0 min-h-0 flex flex-col overflow-hidden',

  /** Inner scroll container — overscroll-contain prevents the pane from
   *  bouncing Word's webview host on macOS. */
  scrollArea:
    'flex-1 h-0 min-h-0 overflow-y-auto overflow-x-hidden overscroll-contain px-4 py-3 space-y-3',

  /** Vertically and horizontally centred placeholder state. */
  centered:
    'flex-1 h-0 min-h-0 flex flex-col items-center justify-center gap-4 p-8 text-center text-muted-foreground',
} as const;

/** Returns the shared layout class strings.
 *  Call signature kept as a hook so callers don't need to change. */
export function useTabLayoutStyles() {
  return tabLayoutClasses;
}
